import { Button } from "@faire/slate/components/button";
import { Calculation } from "@faire/slate-icons/Calculation";
import { Download } from "@faire/slate-icons/Download";

import {
  OVERVIEW_IMAGE_HEADER_CLIP_PX,
  PERFORMANCE_DATE_RANGE,
  PRODUCTION_PERFORMANCE_OVERVIEW_IMAGE,
} from "./productionAssets";

export const PerformanceOverviewCard: React.FC<{
  onOpenBreakevenDrawer: () => void;
}> = ({ onOpenBreakevenDrawer }) => {
  return (
    <section
      className="border-fs-border-muted mx-0 rounded-lg border p-6"
      aria-label="Performance overview"
      data-test-id="performance-overview-card"
    >
      <div className="mb-6 flex items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h2 className="type-fs-subheading-medium text-fs-text-primary">
            Performance overview
          </h2>
          <p className="type-fs-paragraph text-fs-text-subdued">
            {PERFORMANCE_DATE_RANGE}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            variant="secondary"
            size="small"
            iconProps={{ Component: Calculation, position: "start" }}
            onClick={onOpenBreakevenDrawer}
            data-test-id="breakeven-roas-button"
          >
            Breakeven ROAS
          </Button>
          <Button
            variant="secondary"
            size="small"
            iconProps={{ Component: Download, position: "start" }}
          >
            Export
          </Button>
        </div>
      </div>

      <div className="overflow-hidden rounded-lg">
        <img
          src={PRODUCTION_PERFORMANCE_OVERVIEW_IMAGE}
          alt=""
          className="w-full"
          style={{
            marginTop: `-${OVERVIEW_IMAGE_HEADER_CLIP_PX}px`,
          }}
        />
      </div>
    </section>
  );
};
